/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.RESOURCES_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.resources,
                (memo, resource) => {
                    const { id } = resource;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = resource;
                    return memo;
                },
                state,
            );
        },
    },
);